import { render, staticRenderFns } from "./DespesaForm.vue?vue&type=template&id=0a5aac82"
import script from "./DespesaForm.vue?vue&type=script&lang=js"
export * from "./DespesaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports